import { createPublicClient, http } from 'viem';

import { BFF_API_URL } from './const';
import { getChain } from './utils/getChain';

const chain = getChain();

const client = createPublicClient({
  chain,
  transport: http(),
});

const rpcUrl = chain.rpcUrls.default.http[0];

const encodedUrl = encodeURIComponent(rpcUrl);

const bffUrl = rpcUrl ? `${BFF_API_URL}?url=${encodedUrl}` : rpcUrl;
const bffClient = createPublicClient({
  chain,
  transport: http(bffUrl),
});

export function getPublicClient(isBFFApi: false = false) {
  if (isBFFApi) {
    return bffClient;
  }

  return client;
}
